import InsightsGenericWidget from './InsightsGenericWidget'

export default InsightsGenericWidget
